import React, { createContext, useContext, useState } from 'react';

const AllocationContext = createContext();

export const useAllocation = () => {
  const context = useContext(AllocationContext);
  if (!context) {
    throw new Error('useAllocation must be used within an AllocationProvider');
  }
  return context;
};

export const AllocationProvider = ({ children }) => {
  const [allocations, setAllocations] = useState([]);
  const [uploadedBonds, setUploadedBonds] = useState(new Set());

  // Function to add allocation data from CSV upload
  const addAllocation = (bondId, bondData, allocationData) => {
    const newAllocation = {
      id: bondId,
      bondData,
      allocations: allocationData,
      uploadDate: new Date().toISOString(),
      status: 'Allocation Uploaded'
    };
    
    setAllocations(prev => {
      const existingIndex = prev.findIndex(item => item.id === bondId);
      if (existingIndex >= 0) {
        // Update existing allocation
        const updated = [...prev];
        updated[existingIndex] = newAllocation;
        return updated;
      } else {
        // Add new allocation
        return [...prev, newAllocation];
      }
    });
    
    setUploadedBonds(prev => new Set([...prev, bondId]));
  };

  // Function to update allocation status
  const updateAllocationStatus = (bondId, status, additionalData = {}) => {
    setAllocations(prev => prev.map(item => 
      item.id === bondId 
        ? { ...item, status, ...additionalData }
        : item
    ));
  };

  // Function to get allocation by bond ID
  const getAllocationByBondId = (bondId) => {
    return allocations.find(item => item.id === bondId);
  };

  // Function to check if bond has uploaded allocation
  const hasBondAllocation = (bondId) => {
    return uploadedBonds.has(bondId);
  };

  // Function to get all allocations
  const getAllAllocations = () => {
    return allocations;
  };

  const value = {
    allocations,
    uploadedBonds,
    addAllocation,
    updateAllocationStatus,
    getAllocationByBondId,
    hasBondAllocation,
    getAllAllocations
  };

  return (
    <AllocationContext.Provider value={value}>
      {children}
    </AllocationContext.Provider>
  );
};

export default AllocationContext; 